import icon from 'vue-svgicon';

icon.register({
    'bold/arrow-down': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.292 10.24a1.413 1.413 0 0 0-1.994.127l-7.448 8.464a.251.251 0 0 1-.438-.166V1.413a1.412 1.412 0 1 0-2.824 0v17.252a.251.251 0 0 1-.438.166L2.7 10.367a1.413 1.413 0 1 0-2.119 1.867L10.233 23.2a2.352 2.352 0 0 0 3.534 0l9.652-10.967a1.412 1.412 0 0 0-.127-1.993z"/>`,
    },
});
